import { render } from "./IntegracaoInternaPf.vue?vue&type=template&id=05e143e4"
import script from "./IntegracaoInternaPf.vue?vue&type=script&lang=js"
export * from "./IntegracaoInternaPf.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__